import { t } from '@lingui/core/macro';

import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';

import WebTrafficActions from './WebTrafficActions';
import WebTrafficDashboard from './WebTrafficDashboard';
import WebTrafficKPIMetrics from './WebTrafficKPIMetrics';

const WebTraffic = () => {
  return (
    <Page
      title={t`Analytics`}
      pageName={t`Web Traffic`}
      exampleAIQuestions={exampleAIQuestions('analytics')}
      style={{ gap: 24 }}
    >
      <PageFilterProvider>
        <div className="flex h-full w-full flex-col gap-6">
          <div className="flex justify-between">
            <PageDateRangeFilter />
            <WebTrafficActions />
          </div>
          <WebTrafficKPIMetrics />
          <WebTrafficDashboard />
        </div>
      </PageFilterProvider>
    </Page>
  );
};

export default WebTraffic;
